import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'OrDivider',
  props: {
    text: { default: 'or' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})